<script setup lang="ts">
import { computed } from 'vue'
import { envRibbonLabel } from './version'

// Selo inequívoco de ambiente não-produção (REL-UI-03). Vazio em produção.
const label = computed(() => envRibbonLabel())
</script>

<template>
    <div v-if="label" class="env-ribbon" role="status" :aria-label="`Ambiente: ${label}`">
        {{ label }}
    </div>
</template>

<style scoped>
.env-ribbon {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2147483600;
    padding: 4px 12px;
    background: repeating-linear-gradient(
        45deg,
        #b45309,
        #b45309 9px,
        #92400e 9px,
        #92400e 18px
    );
    color: #fff;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.14em;
    line-height: 1;
    border-bottom-right-radius: 7px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    pointer-events: none;
    user-select: none;
}
</style>
